import script from "./SandBoxMaterialForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SandBoxMaterialForm.vue?vue&type=script&setup=true&lang=js"

import "./SandBoxMaterialForm.vue?vue&type=style&index=0&id=3942e67e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3942e67e"]])

export default __exports__